/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-param-reassign */
/* eslint-disable no-undef */
import Vue from 'vue';
import router from '@/router';
import baseURL from '@/api/http-common';

let userObj = ((localStorage.getItem('telasUserObj') !== null) && (localStorage.getItem('telasUserObj').length > 0)) ? JSON.parse(localStorage.getItem('telasUserObj')) : '';
const user = {
  userDetails: {},
  isLoggedIn: false,
  validToken: false,
};

const getters = {
  isUserLoggedIn: state => state.isLoggedIn,
  isUserCourseSubmitter: state => state.userDetails.user_role === 'telas_course_submitters',
  getUserRole: state => state.userDetails.user_role,
  getUserToken: state => state.userDetails.token,
  getUserId: state => state.userDetails.user_id,
  // isUserCourseSubmitter: state => (state.userDetails.roles !== undefined && state.userDetails.roles
  //   .includes('telas_course_submitters')),
};

const actions = {
  async loginUser({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      const response = await Vue.axios.post(`${baseURL}simple-jwt-authentication/v1/token`,
        data);
      const actualData = response.data;
      commit('LOGGEDIN', { actualData, rootState });
    } catch (error) {
      if (typeof error !== 'undefined') {
        const actualData = error.response.data.hasOwnProperty('message') ? error.response.data.message : 'Something went wrong. Please try again.';
        const origin = 'login';
        commit('LOGERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async logoutUser({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      userObj = rootState.user.userDetails.length > 0 ? rootState.user.userDetails : userObj;
      const { userToken } = data;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(`${baseURL}simple-jwt-authentication/v1/token/revoke`, {}, options);
      const actualData = response.data;
      commit('LOGOUT', { actualData, rootState });
    } catch (error) {
      commit('GENERICERROR', { rootState });
    }
    commit('ENDLOADING', { rootState });
  },
  async resetPassword({ commit, rootState }, data) {
    commit('LOADING', { rootState });
    try {
      const response = await Vue.axios.post(`${baseURL}simple-jwt-authentication/v1/token/resetpassword`, data);
      const actualData = response.data;
      const actualResponseStatus = actualData.data.status;
      if (actualResponseStatus === 200) {
        commit('RESETPASSWORD', { actualData, rootState });
      } else {
        commit('RESETPASSWORDERROR', { actualData, rootState });
      }
    } catch (error) {
      commit('GENERICERROR', { rootState });
    }
    commit('ENDLOADING', { rootState });
  },
  async validateToken({ commit, rootState }) {
    commit('LOADING', { rootState });
    try {
      userObj = rootState.user.userDetails.length > 0 ? rootState.user.userDetails : userObj;
      const userToken = userObj.token;
      const options = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      const response = await Vue.axios.post(`${baseURL}simple-jwt-authentication/v1/token/validate`, {}, options);
      const actualData = response.data;
      commit('TOKENVALIDATION', { actualData, rootState });
    } catch (error) {
      if (error.response !== undefined) {
        const actualData = error.response.data.hasOwnProperty('message') ? error.response.data
          .message : 'Something went wrong. Please try again.';
        const origin = 'invalidToken';
        commit('LOGERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async registerUser({ commit, rootState }, formData) {
    commit('LOADING', { rootState });
    try {
      const response = await Vue.axios.post(`${baseURL}extended-telasweb/v1/register`, formData);
      const actualData = response;
      commit('USERREGISTRATION', { actualData, rootState });
    } catch (error) {
      if (typeof error !== 'undefined') {
        const actualData = error.response.data.hasOwnProperty('message') ? error.response.data.message : 'Something went wrong. Please try again.';
        const origin = 'registration';
        commit('LOGERROR', { actualData, rootState, origin });
      }
    }
    commit('ENDLOADING', { rootState });
  },
  async updateUser({ commit, rootState }, formData) {
    commit('LOADING', { rootState });
    try {
      const response = await Vue.axios.post(`${baseURL}extended-telasweb/v1/update-user`, formData);
      const actualData = response.data;
      
      // Check if email was updated AND this is the current user
      if (actualData.email_updated && formData.user_id === rootState.user.userDetails.user_id) {
        // Store new email temporarily
        localStorage.setItem('tempEmail', formData.email);
        
        // Force logout to clear JWT and local state
        commit('LOGOUT', { actualData: {}, rootState });
        
        // Set success message for re-login page
        rootState.common.messages.success = 'Email updated successfully. Please login with your new email address.';
        
        // Redirect to login page
        router.push('/login');
      } else {
        commit('UPDATEUSER', { actualData, rootState });
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.code === 'email_exists') {
        commit('UPDATEUSERERROR', { 
          rootState, 
          message: 'This email address is already in use. Please choose a different one.' 
        });
      } else {
        commit('UPDATEUSERERROR', { rootState });
      }
    }
    commit('ENDLOADING', { rootState });
  },
};


const mutations = {
  LOGGEDIN(state, { actualData, rootState }) {
    if (actualData.hasOwnProperty('user_id')) {
      localStorage.setItem('telasUserObj', JSON.stringify(actualData));
      user.userDetails = actualData;
      user.isLoggedIn = true;
      user.validToken = true;
      rootState.common.messages.errors = '';
      rootState.common.messages.success = '';
    }
  },
  RESETPASSWORD(state, { actualData, rootState }) {
    rootState.common.messages.success = actualData.message;
    rootState.common.messages.errors = '';
  },
  RESETPASSWORDERROR(state, { actualData, rootState }) {
    rootState.common.messages.errors = actualData.message;
    rootState.common.messages.success = '';
  },
  // eslint-disable-next-line no-unused-vars
  LOGOUT(state, { actualData, rootState }) {
    localStorage.setItem('telasUserObj', '');
    user.userDetails = {};
    user.isLoggedIn = false;
    user.validToken = false;
    rootState.common.messages.errors = '';
    rootState.dashboard.userDetails = {};
    rootState.common.messages.success = '';
    router.replace('/login');
  },
  LOGERROR(state, { actualData, rootState, origin }) {
    if (origin === 'login') {
      localStorage.setItem('telasUserObj', '');
      user.userDetails = {};
      rootState.common.messages.errors = actualData;
    } else if (origin === 'registration') {
      rootState.common.messages.errors = actualData;
    } else if (origin === 'invalidToken') {
      rootState.common.messages.errors = actualData;
      user.userDetails = {};
      localStorage.setItem('telasUserObj', '');
      user.isLoggedIn = false;
    }
    if (actualData === 'Wrong number of segments') {
      rootState.common.messages.errors = '';
    }
    rootState.common.messages.success = '';
  },
  TOKENVALIDATION(state, { actualData, rootState }) {
    if (actualData.code === 'jwt_auth_valid_token') {
      user.validToken = true;
      user.isLoggedIn = true;
      user.userDetails = userObj;
      rootState.common.errors = {};
    } else {
      user.validToken = false;
      rootState.common.errors.users = actualData;
      user.isLoggedIn = false;
      router.push('login');
    }
    rootState.common.messages.success = '';
  },
  USERREGISTRATION(state, { actualData, rootState }) {
  },
  UPDATEUSER(state, { actualData, rootState }) {
    rootState.dashboard.userDetails = actualData;
    rootState.common.messages.success = 'Profile updated successfully';
    rootState.common.messages.errors = '';
  },
  LOADING(state, { rootState }) {
    rootState.common.loading = true;
  },
  ENDLOADING(state, { rootState }) {
    rootState.common.loading = false;
  },
  UPDATEUSERERROR(state, { rootState, message }) {
    rootState.common.messages.errors = message || 'Something went Wrong. Please try again.';
    rootState.common.messages.success = '';
  },
  GENERICERROR(state, { rootState }) {
    rootState.common.messages.errors = 'Something went Wrong. Please try again.';
    rootState.common.messages.success = '';
  },
};

export default {
  namespaced: true,
  state: user,
  getters,
  actions,
  mutations,
};
